<template>
  <div style="width: 100%;" id="account">
    <div class="container main-container hidden-sm-and-down">
      <div class="imgbox">
        <img src="../assets/biglogo.png" alt="">
        <span class="title">欢迎注册刘燕酿制官网</span>
      </div>
      <!--pc端页面-->
      <div class="pc">
        <div class="contion">
          <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="手机号码:" prop="tel">
              <el-input onkeyup="this.value=this.value.replace(/\D+/g,'')" type="phone" v-model="ruleForm.tel" autocomplete="off" maxlength="11" placeholder="请输入手机号" ref="phone"></el-input>
            </el-form-item>
      
            <el-form-item label="短信验证码:" prop="telcode">
              <el-input onkeyup="this.value=this.value.replace(/\D+/g,'')" placeholder="请输入短信验证码" style="width: 65%;float: left" type="telcode" label-width="80px" v-model="ruleForm.telcode" autocomplete="off" ref="telcode"></el-input>
              <el-button class="" style="width: 30%;height: 41px;background:#00383F;border-radius:9px;color: #fff;" @click="send">
                <span v-if="sendMsgDisabled">{{time+'秒后获取'}}</span>
                <span v-if="!sendMsgDisabled">获取验证码</span>
              </el-button>
            </el-form-item>
            <el-form-item label="设置密码:" prop="pass">
              <el-input onkeyup="this.value=this.value.replace(/\s+/g,'')" type="password" v-model="ruleForm.pass" show-password autocomplete="off" ref="pwd" placeholder="8-18位密码"></el-input>
            </el-form-item>
            <el-form-item label="请输入密码:" prop="checkPass">
              <el-input onkeyup="this.value=this.value.replace(/\s+/g,'')" type="password" v-model="ruleForm.checkPass" show-password autocomplete="off" ref="pwd2" placeholder="再次输入密码"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button style="width:150px;height: 40px;float: left;background:#00383F;color: #fff;border-radius:9px; " @click="submit()">注册</el-button>
              <router-link style="color: #000;font-size: 18px;" to="/login">已有账号,直接登录</router-link>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>


    <!-- 手机端显示 -->
    <div class="hidden-md-and-up mob">
        <div class="title">
            欢迎登录刘燕酿制官网
        </div>
          <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <el-form-item  prop="tel">
              <el-input onkeyup="this.value=this.value.replace(/\D+/g,'')" type="phone" v-model="ruleForm.tel" autocomplete="off" maxlength="11" placeholder="请输入手机号" ref="phone"></el-input>
            </el-form-item>
      
            <el-form-item prop="telcode">
              <el-input onkeyup="this.value=this.value.replace(/\D+/g,'')" placeholder="请输入短信验证码" style="width: 65%;float: left" type="telcode" label-width="80px" v-model="ruleForm.telcode" autocomplete="off" ref="telcode"></el-input>
              <el-button class="btn" style="width: 30%;height: 41px;background:#00383F;border-radius:9px;color: #fff;float: right;" @click="send">
                <span v-if="sendMsgDisabled">{{time+'秒后获取'}}</span>
                <span v-if="!sendMsgDisabled">获取验证码</span>
              </el-button>
            </el-form-item>
            <el-form-item  prop="pass">
              <el-input onkeyup="this.value=this.value.replace(/\s+/g,'')" type="password" v-model="ruleForm.pass" show-password autocomplete="off" ref="pwd" placeholder="8-18位密码"></el-input>
            </el-form-item>
            <el-form-item  prop="checkPass">
              <el-input onkeyup="this.value=this.value.replace(/\s+/g,'')" type="password" v-model="ruleForm.checkPass" show-password autocomplete="off" ref="pwd2" placeholder="再次输入密码"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button style="width:2.99rem;height: 0.89rem;float: left;background:#00383F;color: #fff;border-radius:unset;font-size:0.33rem " @click="submit()">注册</el-button>
              <router-link style="color: #000;font-size: 0.26rem;float:right" to="/login">已有账号,直接登录</router-link>
            </el-form-item>
          </el-form>
    </div>
  </div>
</template>
<script>
  // import draw from "./Graphiccode.js"
import {registerAPI,send_code_API,PostLoginAPI} from '../request/api'

  export default {
    name: "account",
    data() {
      let checkTel = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('手机号不能为空'));
        } else {
          const reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error('请输入正确的手机号'));
          }
        }
      };
      let validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else if (value.length < 8) {
          callback(new Error('密码长度不够'));
        } else if (value.length > 18) {
          callback(new Error('密码最长18位'));
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      let validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else if (value.length < 8) {
          callback(new Error('密码长度不够'));
        } else if (value.length > 18) {
          callback(new Error('密码最长18位'));
        } else {
          callback();
        }
      };
      return {
        time: '60',
        sendMsgDisabled: false,
        ruleForm: {
          pass: '',
          checkPass: '',
          tel: '',
          telcode:''
        },
        rules: {
          pass: [
            {validator: validatePass, trigger: 'blur'}
          ],
          checkPass: [
            {validator: validatePass2, trigger: 'blur'}
          ],
          tel: [
            {validator: checkTel, trigger: 'blur'}
          ],
          telcode: [
            {required: true, message: '验证码不可为空', trigger: 'blur'},
            { min: 6, max: 6, message: '验证码为6位数字', trigger: 'blur' }
          ],
        }
      };
    },

    methods: {


    submit() {
        let Datalist = {
          "phone": this.$refs.phone.value,
          "password": this.$refs.pwd.value,
          "code": this.$refs.telcode.value,
          "password_confirmation": this.$refs.pwd2.value,
        };
        if (this.$refs.phone.value.length<11 || this.$refs.phone.value == '' || this.$refs.pwd.value == '' || this.$refs.telcode.value == undefined || this.$refs.pwd2.value == '' || this.$refs.pwd.value.length < 8) {
         this.$message.error("请输入完整信息");
          return false
        }
        if(this.sendMsgDisabled==true){
            registerAPI(Datalist).then((res)=>{
                if (res.data.code === 100) {
                this.$message.error(res.data.message);
                }
                if (res.data.code === 200) {
                    this.$message.success(res.data.message);
                    let token = res.data.token;
                    let postParams = {'phone': Datalist.phone, 'password':Datalist.password};
                    PostLoginAPI(postParams).then(res=>{
                            if (res.data.code === 200) {
                              console.log('登录成功')
                            localStorage.setItem('userToken',res.data.data.token);
                            this.$store.dispatch('setLogin', res.data.data.token);
                            this.$message.success('登录成功');
                            this.$router.push({path: '/'})
                            }
                    })
                   
                }
            })
        
        }

      },
    send() {
        let userInfo = {
          "phone": this.$refs.phone.value,
          "lostatus": "register"
        };
        let me = this;
        me.sendMsgDisabled = true;
        let phone = this.$refs.phone.value
        let reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
        if (phone !== ""&& reg.test(phone)) {
          let interval = window.setInterval(function () {
            if ((me.time--) <= 0) {
              me.time = 60;
              me.sendMsgDisabled = false;
              window.clearInterval(interval);
            }
          }, 1000);
        } else {
          this.$message.error("请输入手机号");
          me.sendMsgDisabled = false;
          return false
        }
        send_code_API(userInfo).then((res)=>{
                if (res.data.code === 100) {
                  this.$message.error(res.data.message);
                  me.sendMsgDisabled = false;
                }
                if (res.data.code === 200) {
                this.$message.success("验证码发送成功");
                }
        })
  
      },
    },
  };
</script>

<style lang="less" scoped>
 .container{
     width: 100%;
     color: #00383F;
     .imgbox{
             width: 60%;
            margin: 0 auto;
            padding-top: 165px;
            h1{
                padding: 6% 0;
            }
            span{
                    display: block;
                    font-size: 18px;
                    margin-bottom: 60px;
            }
     }
     .pc{
         width: 100%;
        margin: 0 auto;
        padding-bottom: 150px;
        .containers{
            max-width: 600px;
            margin: 0 auto;
            .demo-ruleForm{
                width: 70%;
                margin: 0 auto;
            }
            .btn{
                width: 135px;
                height: 40px;
                float: left;
                margin-top: 30px;
                margin-left: 20%;
                background: #00383F;
                color: #fff;
            }
        }
        .contion{
            max-width: 650px;
            margin: 0 auto;
         .demo-ruleForm {
                width: 70%;
                margin: 0 auto;
            }
        }
     }
 }
 @media (max-width: 991px) {
  .mob{
    padding-top: 1rem;
    margin: 0 0.5rem;
    margin-bottom: 3rem;
    .title{
      font-size: 0.4rem;
      font-weight: 900;
      color: #00383F;
      padding-bottom: 0.79rem;
    }
    .btn{
      height: 0.803rem!important;
      font-size: 0.24rem;
      border-radius: unset!important;
    }
  }
  /deep/.el-input__inner{
    height: 0.803rem;
  }
  /deep/.el-input__inner::placeholder{
    text-align: left;
    font-size: 0.24rem;
  }
 
 }
</style>


// WEBPACK FOOTER //
// src/view/Account.vue